import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { monthLabel } from "@/lib/format";

export function UnsavedDialog({ month, open, onStay, onLeave }: { month: string; open: boolean; onStay: () => void; onLeave: () => void }) {
  return (
    <AlertDialog open={open} onOpenChange={(o: boolean) => !o && onStay()}>
      <AlertDialogContent className="bg-white" data-testid="unsaved-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-[#1B2A4A]">Cambios sin guardar</AlertDialogTitle>
          <AlertDialogDescription data-testid="unsaved-dialog-text">
            Has realizado cambios sin guardar en tu presupuesto de {monthLabel(month)}. Si sales ahora, se perderán los cambios.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onStay} data-testid="unsaved-stay-button">Seguir editando</AlertDialogCancel>
          <AlertDialogAction onClick={onLeave} className="bg-[#B23A1E] text-white hover:bg-[#962F17]" data-testid="unsaved-leave-button">Salir sin guardar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
